import { render, staticRenderFns } from "./_DesignButtonStyles.vue?vue&type=template&id=644fc8ac&"
import script from "./_DesignButtonStyles.vue?vue&type=script&lang=ts&"
export * from "./_DesignButtonStyles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports